import {IProfileItemModel, ProfileItemModel} from './profile-item.model';

export interface IAusbildung extends IProfileItemModel {
  uuid?: string;
  beginn?: Date | string;
  ende?: Date;
  ausbildungseinrichtung?: string;
  ausbildungsgang?: string;
  ort?: string;
  abschlussErreicht?: boolean;
  abschluss?: string;
}

export class Ausbildung extends ProfileItemModel implements IAusbildung {
  constructor(
    public uuid?: string,
    public beginn?: Date,
    public ende?: Date,
    public ausbildungseinrichtung?: string,
    public ausbildungsgang?: string,
    public ort?: string,
    public abschlussErreicht?: boolean,
    public abschluss?: string
  ) {
    super();
    this.beginn = beginn ? beginn : new Date(Date.now());
    this.ende = ende ? ende : undefined;
    this.ausbildungseinrichtung = ausbildungseinrichtung ? ausbildungseinrichtung : undefined;
    this.ausbildungsgang = ausbildungsgang ? ausbildungsgang : undefined;
    this.ort = ort ? ort : undefined;
    this.abschlussErreicht = abschlussErreicht ? abschlussErreicht : undefined;
    this.abschluss = abschluss ? abschluss : undefined;
  }

  static emptyObject(): Ausbildung {
    const data = new Ausbildung();
    data.beginn = new Date();
    data.ende = new Date();
    data.ausbildungseinrichtung = '';
    data.ausbildungsgang = '';
    data.ort = '';
    data.abschlussErreicht = false;
    data.abschluss = '';
    return data;
  }

  static fromJson(json: IAusbildung) {
    const data = new Ausbildung();
    data.uuid = json.uuid;
    data.ausbildungseinrichtung = json.ausbildungseinrichtung;
    data.ausbildungsgang = json.ausbildungsgang;
    data.ort = json.ort;
    data.abschlussErreicht = json.abschlussErreicht;
    data.beginn = this.anyToDate(json.beginn);
    data.ende = this.anyToDate(json.ende);
    data.abschluss = json.abschluss;
    return data;
  }

  newInstance<T extends ProfileItemModel>(): T {
    return new Ausbildung() as T;
  }
}
